<template>
    <v-container fluid>
        <v-col :alvqa="alvqa + 'sub-catalogues-title'">
            <v-row class="pl-4 pb-4 headline">
                {{ item.contractName }}
            </v-row>
        </v-col>

<!-- Contract Details -->
        <!-- <v-row class="pl-4 pr-4">
            <v-col>
                <v-card elevation="0">
                    <v-card-text>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <PublishingContractsConditionsReadOnlyPanel/>
                    <PublishingContractsAdvanceReadOnlyPanel/>
                    <PublishingContractsCostsReadOnlyPanel/>
                    <PublishingContractsGroupedContractsReadOnlyPanel/>
                    <PublishingContractsAgreementNumbersReadOnlyPanel :contractAlvId="item.alvId" />
                    <PublishingContractsSubCataloguesReadOnlyPanel :contractAvlId="item.alvId" />
                    <PublishingContractsSubCataloguesReadOnlyPanelDialog />
                    <DeletionDialog context="SelectedPublishingContractsSubCatalogues" />
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template> 

<script>
import PublishingContractsGroupedContractsReadOnlyPanel from './_panels/groupedContracts/PublishingContractsGroupedContractsReadOnlyPanel'
import PublishingContractsSubCataloguesReadOnlyPanel from './_panels/subcatalogues/PublishingContractsSubCataloguesReadOnlyPanel'
import PublishingContractsSubCataloguesReadOnlyPanelDialog from './_panels/subcatalogues/PublishingContractsSubCataloguesReadOnlyPanelDialog'
import PublishingContractsConditionsReadOnlyPanel from './_panels/conditions/PublishingContractsConditionsReadOnlyPanel.vue';
import PublishingContractsAdvanceReadOnlyPanel from './_panels/advance/PublishingContractsAdvanceReadOnlyPanel.vue';
import PublishingContractsCostsReadOnlyPanel from './_panels/costs/PublishingContractsCostsReadOnlyPanel.vue';
import PublishingContractsAgreementNumbersReadOnlyPanel from './_panels/agreementNumbers/PublishingContractsAgreementNumbersReadOnlyPanel.vue';
import DeletionDialog from '@/components/_dialogs/DeletionDialog'

export default {
    name: "PublishingContractsReadOnly",
    components: {
        PublishingContractsGroupedContractsReadOnlyPanel,
        PublishingContractsSubCataloguesReadOnlyPanel,
        PublishingContractsSubCataloguesReadOnlyPanelDialog,
        PublishingContractsConditionsReadOnlyPanel,
        PublishingContractsAdvanceReadOnlyPanel,
        PublishingContractsCostsReadOnlyPanel,
        PublishingContractsAgreementNumbersReadOnlyPanel,
        DeletionDialog
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'publishing-contracts-list-row-' + this.itemId + '-read-only'
        }
    },
    computed: {
        item() { 
            let item = this.$store.getters.getExpandedPublishingContracts.find(element => {
                return element.id === this.itemId
            })

            return item
        },
    }
}
</script>